import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AgaveAuthService } from 'tq-agave';


/**
 * Permette l'accesso alla pagina solo a utenti non autenticati. Effettua la login
 * automatica con il ticket nello storage o nei queryParameter, se lo trova.
 *
 * Se l'utente è autenticato o se l'auto-autenticazione va a buon fine, l'utente viene rimbalzato sulla pagina di default.
 * */
export const NoAuthGuard: CanActivateFn | CanActivateChildFn = async (route, state) => {
    const appAuthService = inject(AuthService);
    const agaveAuthService = inject(AgaveAuthService);
    const router: Router = inject(Router);

    if ('ticket' in route.queryParams) {
        const ticket = route.queryParams['ticket'];
        // Il vecchio ticket andrebbe invalidato?
        // Se è diverso da quello in memoria, ovvio...
        // Comunque penso di no: non in tutti i casi andrebbe invalidato
        // await agaveAuthService.logOut();
        let rememberMe = false;
        try {
            rememberMe = Boolean(JSON.parse(route.queryParams['rememberMe'])) ?? false;
        } catch (e) { }
        await agaveAuthService.authenticateFromTicket(ticket, rememberMe);
    }

    // Check the authentication status
    const authenticated = await appAuthService.check();
    // If the user is authenticated...
    if ( authenticated )
    {
        return router.parseUrl('');
    }

    // Allow the access
    return true;
};
